import { render, staticRenderFns } from "./IconTruck.vue?vue&type=template&id=10415a69"
import script from "./IconTruck.vue?vue&type=script&lang=js"
export * from "./IconTruck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports